<template lang="pug">
	content-page
		div(slot="nav")
			nav
				.subtitle-1 Categorieën
				ul.mb-0.list-unstyled
					li.nav-list-item
						nuxt-link(:to="localePath({name:'weblog'})")
							forum-icon.mr-1(small) weblog
							| {{$t('forum-navigation:link.weblog')}}
					li
						nuxt-link(:to="localePath({name:'news'})")
							forum-icon.mr-1(small) news
							| {{$t('forum-navigation:link.news')}}
				ul.list-unstyled(v-if="$store.state.user.id")
					li.nav-list-item
						nuxt-link(:to="localePath({name:'forum-category', params: {category: 'favorieten'}})")
							v-icon.mr-1(small color="#ff5a5e") favorite
							| {{$t('forum-navigation:link.favorites')}}
				ul.list-unstyled
					li.nav-list-item(v-for="child in pages" :key="child.slug" v-if="!child.isHiddenInMenu")
						nuxt-link(:to="localePath({name:'forum-category', params: {category: child.slug}})")
							forum-icon.mr-1(small) {{child.category}}
							| {{child.menu_title}}
		div.hidden-sm-and-down(slot="sidebar" v-if="showSidebar" style="max-width: 280px;")
			ad(location="sidebar").mb-6
			snow-alarm.mb-6

			offers.mb-6
		.flow-left
			nuxt-child(:showSidebar.sync="showSidebar")
</template>

<script>
import gql from 'graphql-tag';
import ForumIcon from '@dengl/common/components/forum/icon';

const query = gql`
	query getForumNavigation($path: String!) {
		contentpage(path: $path) {
			id
			children {
				name
				slug
				isHiddenInMenu
				menu_title
			}
		}
	}
`;

export default {
	name: 'Forum',
	nuxtI18n: {
		paths: {
			'nl-NL': '/forum',
			'nl-BE': '/forum'
		}
	},
	components: { ForumIcon },
	// eslint-disable-next-line @milqmedia/milq/page-has-meta, @milqmedia/milq/page-has-ads
	asyncData({ app, route }) {
		return app.$graphClient
			.query({
				query,
				variables: {
					path: route.path.split('/', 2).join('/')
				},
				errorPolicy: 'all'
			})
			.then(({ data, errors }) => {
				if (!data.contentpage) {
					return app.httpError(404, null, 'forum-index-01', errors);
				}
				return { data, errors };
			})
			.then(({ data, errors }) => {
				if (errors) {
					throw errors[0];
				}
				return data;
			})
			.catch(error => {
				return app.httpError(500, null, 'forum-index-01', error);
			});
	},
	data() {
		return {
			showSidebar: false
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		pages() {
			return this.contentpage.children.map(page => {
				page = {
					...page,
					...this.$store.state.forumCategories.find(category => {
						return (
							category.slugs[this.$i18n.locale.split('-')[0]] === page.slug
						);
					})
				};

				return page;
			});
		}
	}
};
</script>
